import { UserRole } from './user-role';
import { UserStatus } from './user-status';

export interface User {
    id: number;
    status: UserStatus;
    username: string;
    role: UserRole;
    email: string;
    creatorUsername: string;
    createdAt: string;
}
